export function curry1(fn) {
    function curried(a) {
        switch (arguments.length) {
            case 0: return curried;
            default: return fn(a);
        }
    }
    return curried;
}
;
//# sourceMappingURL=curry1.js.map